<template>
    <div>
        <header-section
            title="Reserve vs Paid Comparison"
            set-position="relative"
            set-width="100">
        </header-section>
        <div id="app" class="o-content ie p-reserving p-compare-reserve u-margin-bottom-40">
            <claims-dashboard-icons></claims-dashboard-icons>
            <p class="u-margin-bottom-30">
                Compare the accuracy of your initial or final reserves against paid
                settlements
            </p>
            <compare-form></compare-form>
            <div v-if="calculating" class="a-loader--results"></div>
            <div class="flex-grid flex-grid--reduced-bottom-margin" v-if="claims.length && !calculating">
                <div class="u-full-width">
                    <range-chart-container></range-chart-container>
                </div>
            </div>
            <slider v-if="claims.length && !calculating"></slider>
            <results-table v-if="claims.length && !calculating"></results-table>

            <div v-if="claims.length && !calculating" class="p-compare-reserve__charts">
                <div class="u-margin-bottom-30">
                    <difference-chart></difference-chart>
                </div>
                <div class="u-d-flex u-flex-center">
                    <button v-if="claims.length && !calculating" class="a-button a-button--small u-margin-top-10" @click="showClaimTable = !showClaimTable">
                        {{showClaimTable ? 'Hide' : 'Show'}} Table Of Claims
                    </button>
                </div>
                <claim-table v-if="claims.length && showClaimTable"></claim-table>
                <div class="u-margin-bottom-40">
                    <fee-earner-chart></fee-earner-chart>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import CompareForm from './components/Form';
    import ClaimTable from "./components/ClaimTable";
    import FromTo from "./components/FromTo";
    import Search from "./components/Search";
    import DifferenceChart from "./components/DifferenceChart";
    import ClaimsDashboardIcons from 'pages/claims-dashboard/components/Icons';
    import {mapGetters, mapActions} from 'vuex';
    import FeeEarnerChart from "./components/FeeEarnerChart";
    import RangeChartContainer from "./components/RangeChartContainer";
    import Slider from "./components/Slider";
    import ResultsTable from "./components/ResultsTable";
    import HeaderSection from 'components/Header.vue';

    export default {
        name: 'compare-values',
        components: {
            ResultsTable,
            Slider,
            RangeChartContainer,
            FeeEarnerChart,
            DifferenceChart,
            Search,
            FromTo,
            ClaimTable,
            CompareForm,
            ClaimsDashboardIcons,
            HeaderSection
        },
        data: () => ({
            showClaimTable: false
        }),
        computed: {
            ...mapGetters('reserves/compare', ['claims', 'calculating', 'hasClaims']),
        }
    }

</script>


// WEBPACK FOOTER //
// CompareValues.vue?726740ff